<template>
  <modal class="fastFreeShippingModel" :isShow="isShow" @keyup.esc="hide">
    <div class="header">免单信息确认</div>
    <div class="modal-body">
        <div class="left-box">
            <div class="money-info">
                <div class="lable-txt" >
                    待支付金额：<b class="noney red" v-show="unPaidMoney">{{Number(unPaidMoney).toFixed(2)}}</b>
                </div>
            </div>
            <div class="notes" v-show="maxPayMoney">
                注:本单最大可用免单金额{{maxPayMoney}}元
            </div>
            <div class="tr-box payamount">
                <div class="label-txt">付款金额:</div>
                <div class="from-input">
                    <input-pattern ref="money" data-model='money' v-model="money" pattern="money" :max="maxPayMoney" @focus="(e)=>e.target.select()"   />
                </div>
            </div>
            <div class="title-box">招待信息</div>
            <div class="tr-box">
                <div class="label-txt">招待客户:</div>
                <div class="from-input">
                    <input type="text" ref="customer" v-model="customerName"/>
                </div>
            </div>
            <div class="tr-box">
                <div class="label-txt">免单确认人:</div>
                <div class="from-input">
                    <input type="text" ref="poerson" v-model="freeConfirmPerson"/>
                </div>
            </div>
            <div class="tr-box">
                <div class="label-txt">备注:</div>
                <div class="from-input">
                    <input type="text" v-model="remark"/>
                </div>
            </div>
        </div>
        <div class="right-box">
            <div class="keyboard">
                <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                        data-value="9">9</span></div>
                <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                        data-value="6">6</span></div>
                <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                        data-value="3">3</span></div>
                <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                        data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
            </div>
        </div>
    </div>
    <div class="footer-box">
        <button class="btn btn-cancel" @click="hide()">取消</button>
        <button class="btn btn-confirm" @click="confirm()" v-throttle>确认</button>
    </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

/**会员支付 */
export default {
    name:"scanCodePayModel",
    emits:["cashConfirm","close"],
    props:{
        //是否显示
        isShow:{
            type:Boolean,
            default:false
        },
        //待支付金额
        unPaidMoney:{
            type:Number,
            default:null
        },
        //支付方式数据
        choicePayType:Object,
        /**订单 金额信息 */
        totalOrderMoney:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            userInfo:null,
            money:"",
            //招待客户
            customerName:"",
            //免单确认人
            freeConfirmPerson:"",
            //备注
            remark:"",
            /**支付金额最大可输入多少 */
            maxPayMoney:null
        }
    },
    mounted(){
        this.userInfo=this.$auth.getUserInfo(); //获取用户id
        this.$nextTick(()=> {
            initKeyBoard.call(this,this.$el,this.$refs.money?.$el);
            this.init();
        })
    },
    watch: {
        //用于观察数据变动。对应一个对象,键是观察表达式,值是对应回调。子组件中 需要结合watch监听
        isShow() { 
            if(this.isShow){
                this.init();
            }
        }
    },
    methods:{
        init(){
            this.money='';
            if(this.maxPayMoney>0){
                if(this.maxPayMoney>this.unPaidMoney){
                    this.money=this.unPaidMoney;
                }else{
                    this.money=this.maxPayMoney;
                }
            }

            if(this.choicePayType?.INTERFACE_TYPE==6){//支付类型为免单时
                let freeMoney=this.userInfo?.LimitedFreeMoneyOfEachBill||0;
                if(this.userInfo?.LimitedFreeMoneyOfEachBillType==1){//金额 
                    this.maxPayMoney=freeMoney;
                }else if(this.userInfo?.LimitedFreeMoneyOfEachBillType==2){//折前消费金额%
                    this.maxPayMoney= Number(this.totalOrderMoney.sumMoney).compute((freeMoney/100),'*');
                }else if(this.userInfo?.LimitedFreeMoneyOfEachBillType==3){//折后消费金额%
                    this.maxPayMoney= Number(this.totalOrderMoney.totalMoney).compute((freeMoney/100),'*');
                }
            }

            setTimeout(() => {
                this.$refs.money.focus();
            },100);
        },
        hide(){
            this.$emit("close");
        },
        /**确定和回车事件 */
        confirm(){
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let giveFreeExtendInfo={
                CustomerName:this.customerName.trim(),//招待客户
                FreeConfirmPerson:this.freeConfirmPerson.trim(),//免单确认人
                Remark:this.remark.trim(),//备注
            }
            if(!(Number(this.money)>0)){
                this.$message.warning("付款金额必须大于0!");
                this.$refs.money.focus();
                return;
            }
            if(!giveFreeExtendInfo.CustomerName && !giveFreeExtendInfo.FreeConfirmPerson && !giveFreeExtendInfo.Remark){
                giveFreeExtendInfo=null;
            }

            if(Number(this.money)>=0){
                this.$emit('cashConfirm',this.money,{
                    GiveFreeExtendInfo:giveFreeExtendInfo//免单信息
                });
            }else{
                this.$message.warning("付款金额必须大于0!");
                return
            }
        },
    }
}
</script>

<style lang="sass">
@import "./fastFreeShippingModel.scss";
</style>